import React from "react";
import {Provider} from "react-redux";
import CartIcon from "./CartIcon";
import {getStore} from "../../reducers/cart_icon_reducer";

const CartIconWithProvider = (props) => {
  return (
    <Provider store={getStore(props)}>
      <CartIcon {...props}/>
    </Provider>
  )
};

export default CartIconWithProvider;